import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../../enums';
import { beforeEnter } from './../../guards';

const Component = () => import('./CentricHubConfig.vue');

export default {
  path: buildChildURL(
    SitesRoutePathNames.SITE,
    SitesRoutePathNames.STATION_DETAILS,
    SitesRoutePathNames.STATION,
    SitesRoutePathNames.CENTRIC_HUB,
  ),
  name: SitesRouteNames.SITE_STATION_CENTRIC_HUB,
  component: Component,
  beforeEnter: beforeEnter,
} as RouteRecordRaw;
